<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5UzWSw/tc-custom/9781607050964.jpg?1709098666207" alt="This image is the cover for the book Super Simple Quilts #3"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Super Simple Quilts #3
      </h1>
      <p class="bookDescription body article font2">
        <b>Three super-easy quilts, each in three sizes, with three fabric styles to choose from. One supply list makes all the quilts. Nothing could be simpler.</b><br/><br/><b>Easy, Speedy, and Fun!</b><br/><br/>• Nine all-new Super Simple quilt projects offer three fun designs in three sizes and three colorful fabric styles: New Retro, Floral, and Graphic<br/><br/>• One supply list is all you need for all nine quilts-buy the fabric first, then decide which quilt to make<br/><br/>• Easy strips, squares, and triangles make piecing a breeze<br/><br/>• Great as gifts or charity quilts<br/><br/>Here's help for time-challenged quilters: nine all-new Super Simple projects that take almost no time to put together, finish, and embellish. Choose from three designs, in three sizes, and three vivid color schemes. Add three simple quilting techniques and three quick ways to bind and finish. What could be simpler?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alex Anderson, Liz Aneloski
      </h2>
      
      <p class="authorDescription body article">Liz Aneloski Bio: Liz Aneloski's talents run the gamut from innovative quilting techniques to using photographs and embellishments in fun ways. She enjoys combining elements of her different passions to create new art forms. Liz lives in Northern California.   Alex Anderson Bio: Alex Anderson seeks to educate, inspire, entertain, and grow today’s quilting community. A longtime host of the TV show Simply Quilts, she is also executive producer and co-host of the web TV’s The Quilt Show with Ricky Tims. Alex lives in Northern California. alexandersonquilts.com and thequiltshow.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      C&T Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?00e6f0ae